import CloudFunctionsHost from './CloudFunctionsHost';
export default CloudFunctionsHost;